// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"12f7491b","495":"64941548","549":"28bd9dd0","756":"5e7df3e1"}[chunkId] + ".chunk.css";
};